import { render, staticRenderFns } from "./VueNativeSelect.vue?vue&type=template&id=01fdc2d2&scoped=true&"
import script from "./VueNativeSelect.vue?vue&type=script&lang=js&"
export * from "./VueNativeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdc2d2",
  null
  
)

export default component.exports